<template>
  <div v-if="selectedMenu == 1" class="uv-card">
    <div class="uv-card-body">
      <h3 class="uv-card-title">Grupos Clientes</h3>
      <uv-data-table
        :config="config"
        :data="grupos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>

    <modal v-model="showModal" :showFooter="false" title="Grupos clientes">
      <GruposClientesForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        @reload="getUserGroups"
        :dataEdit="editData"
      ></GruposClientesForm>
    </modal>
  </div>
</template>

<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import Cliente from "../../../clases/Cliente.js";
import GruposClientesForm from "./GruposClientesForm.vue";

export default {
  name: "GruposClientesCRUD",
  components: {
    uvDataTable,
    modal,
    GruposClientesForm,
  },
  data() {
    return {
      editMode: false,
      grupos: [],
      editData: {},
      formIndex: 1,
      indexComponent: 1,
      access: [],
      showModal: false,
      config: {
        orderByCol: { Field: "Apellidos", Type: "Asc" },
        allowExport: true,
        rawText: "Grupos Clientes",
        selectableRow: true,
        selectConfig: {
          idRowData: "name", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addClient",
          },

          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteGrupo",
            require: true,
          },
        ],
        fields: [
          {
            text: "Grupo",
            value: "name",
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      claims: {},
      //data_clientes:[],
      selectedMenu: 1,
    };
  },
  computed: {},
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addClient") {
        this.editMode = false;
        this.editData = {};
        this.formIndex++;
        this.toggleModal(true);
      }
    
      if (buttonId == "deleteGrupo") {
        this.deleteGrupo(idSelected[0]);
      }
    },
    deleteGrupo(id) {
      
      let dataSend = {
        gps:[id]
      }
      
      this.$alert.alertConfirm(
        {
          action:"eliminar",
          obj:"el grupo de clientes",
          route:'PDV-GruposClientes-remGruposCliente',
          data:dataSend,
          onSuccess:()=>{
            this.getUserGroups()
          }
        }
      );

    },
    async getUserGroups() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_GruposCliente", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      
      let gps = [];
      if (document) {
        document.forEach((doc) => {
          if (doc.gps) {
            let grupos = Object.entries(doc.gps)
            grupos.forEach((element) => {
              if(element[1]){
                gps.push({
                name: element[0],
              });
              }
              
            });
            this.grupos = gps;
          }
        });
      }
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function() {},
  mounted: function() {
    this.getUserGroups();
  },
};
</script>
